import styled from "styled-components";

export const Container = styled.div`
  width: min(90%, 1400px);
  margin-inline: auto;
`